import { render, staticRenderFns } from "./OrganisationFormSection.vue?vue&type=template&id=2b31f49f&scoped=true&"
import script from "./OrganisationFormSection.vue?vue&type=script&lang=ts&"
export * from "./OrganisationFormSection.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationFormSection.vue?vue&type=style&index=0&id=2b31f49f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31f49f",
  null
  
)

export default component.exports